module.exports = __webpack_public_path__ + "media/open-sans/OpenSans-LightItalic-21bfc6e1.eot";